__turbopack_context__.v({
  "root": "AnimatedTitle-module-scss-module__X2--2G__root",
  "title": "AnimatedTitle-module-scss-module__X2--2G__title",
});
